import React, { useEffect } from "react";
import { LineChart, Line, ResponsiveContainer } from "recharts";

const useArrowHeadMarker = (color, id) => {
  useEffect(() => {
    if (!document.getElementById(id)) {
      const svgNS = "http://www.w3.org/2000/svg";
      const marker = document.createElementNS(svgNS, "marker");
      marker.setAttribute("id", id);
      marker.setAttribute("viewBox", "0 0 10 10");
      marker.setAttribute("refX", "5");
      marker.setAttribute("refY", "5");
      marker.setAttribute("markerWidth", "6");
      marker.setAttribute("markerHeight", "6");
      marker.setAttribute("orient", "auto-start-reverse");

      const path = document.createElementNS(svgNS, "path");
      path.setAttribute("d", "M 0 0 L 10 5 L 0 10 z");
      path.setAttribute("fill", color);
      marker.appendChild(path);

      const svg = document.querySelector("svg");
      if (svg) {
        const defs =
          svg.querySelector("defs") ||
          svg.insertBefore(document.createElementNS(svgNS, "defs"), svg.firstChild);
        defs.appendChild(marker);
      }
    }
  }, [color, id]);
};

const ArrowTrendChart = ({ change }) => {
  const isPositive = change > 0;
  const isNegative = change < 0;
  const isNeutral = change === 0;

  const color = isPositive ? "#198754" : "#dc3545";
  const markerId = isPositive
    ? "arrowhead-green"
    : isNeutral
      ? "arrowhead-red-flat"
      : "arrowhead-red";

  useArrowHeadMarker(color, markerId);

  const chartData = isPositive
    ? [{ value: 40 }, { value: 60 }, { value: 75 }]
    : isNegative
      ? [{ value: 75 }, { value: 55 }, { value: 40 }]
      : [{ value: 50 }, { value: 50 }, { value: 50 }];

  return (
    <div style={{ width: "45px", height: "50px" }}>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={chartData}>
          <Line
            type="monotone"
            dataKey="value"
            stroke={color}
            strokeWidth={3}
            dot={false}
            isAnimationActive={false}
            strokeLinecap="round"
            style={{
              markerEnd: `url(#${markerId})`,
            }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ArrowTrendChart;
